import "./App.css";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
// import AnniversaryBar from "./components/common/AnniversaryBar";
import UTMTracking from "./components/common/UTMTracking";
import PrivacyDialog from "./components/common/PrivacyDialog"
import ChatBots from "./components/common/ChatBots"
import "./i18n";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import routers from "./routers";

function App() {
  // let { i18n } = useTranslation();
  const location = useLocation()
  const isShow = !location.pathname.includes('privacy');
  return (
    <div className="App">
      <UTMTracking />
      {isShow && <Header />}
      <Routes>
        {routers.map((item, index) => {
          if (item.path === '*') {
            return (
              <Route key={item.title || index} path="*" element={<Navigate to="/" replace={true} />} />
            )
          }
          return (

            <Route
              key={item.title || index}
              exact
              path={item.path}
              element={<item.component location={location} />}
            />

          );
        })}
      </Routes>
      {isShow && <Footer />}
      <PrivacyDialog />
      <ChatBots />
    </div>
  );
}

export default App;
